module.exports = __webpack_public_path__ + "img/info_Card3.7aacf62c.png";